const encodeSVG = (data)=>data.replace(/"/g, `'`).replace(/>\s{1,}</g, `><`).replace(/\s{2,}/g, ` `).replace(/[\r\n%#()<>?[\\\]^`{|}]/g, encodeURIComponent);
const createLoaderSvg = (color)=>encodeSVG(`<svg xmlns='http://www.w3.org/2000/svg' width="20px" height="20px" style="animation: animation-root 1.4s linear infinite" viewBox="22 22 44 44">
	<style>
	@keyframes animation-loader {
	  0% {
		stroke-dasharray: 1px, 200px;
		stroke-dashoffset: 0;
	  }

	  50% {
		stroke-dasharray: 100px, 200px;
		stroke-dashoffset: -15px;
	  }

	  100% {
		stroke-dasharray: 100px, 200px;
		stroke-dashoffset: -125px;
	  }
	}

	@keyframes animation-root {
	  0% {
		transform: rotate(0deg);
	  }

	  100% {
		transform: rotate(360deg);
	  }
	}
	</style>
	<circle style="animation: animation-loader 1.4s ease-in-out infinite" cx="44" cy="44" r="18" fill="none" stroke="${color}" stroke-width="8" stroke-dasharray="80px, 200px"
	stroke-dashoffset="0"></circle>
  </svg>
  `);
export const dataLoaderVariant = {
    props: {
        'data-loader': true
    },
    style: ({ theme })=>({
            '&::after': {
                content: `url("data:image/svg+xml,${createLoaderSvg(theme.palette.primary.main)}")`,
                position: 'absolute',
                top: 'calc(50% - 10px)',
                left: 'calc(50% - 10px)'
            }
        })
};
